import { Icon } from 'ehs-react';
import React from 'react';

export function InlineError({
  title,
  text
}: Readonly<{
  title: string;
  text: string;
}>): JSX.Element {
  return (
    <div className="inline-error-container" role="alert">
      <div className="inline-error-title font-18 s-font">
        <Icon
          iconName={'shui_error'}
          className={`inline-error-title-icon`}
          aria-label={undefined}
        />
        <div className="inline-error-title-text">{title}</div>
      </div>
      <div className="inline-error-text font-16 s-font">{text}</div>
    </div>
  );
}
